import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import LoaderComponent from '@components/LoaderComponent';
import NoData from '@components/NoData';
import { toastError, toastSuccess } from '@components/Toast';

import EditButton from '@features/supplier/component/EditButton';

import { fetchSupplierDetails } from '@store/supplier/action';

import ApiClient from '@lib/apiClient';

import { capitalizeFirstLetter, getNumberUnit, validateNumber } from '@utils/Util';

import { BASE_URL } from '@/constants/constant';

const ProductionCapacity = ({ supplierInfo }) => {
	const [show, setShow] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [productionCapacity, setProductionCapacity] = useState(null);
	const [inputData, setInputData] = useState(null);
	const { id } = useParams();
	const dispatch = useDispatch();

	useEffect(() => {
		if (supplierInfo?.productionCapacity) {
			setProductionCapacity(supplierInfo.productionCapacity);
			setInputData(supplierInfo.productionCapacity);
		}
	}, [supplierInfo?.productionCapacity]);

	const handleClose = () => {
		setShow(false);
		setInputData(supplierInfo.productionCapacity);
	};

	const handleChange = (e) => {
		e.preventDefault();
		let { name, value } = e.target;
		setInputData((prev) => ({
			...prev,
			[name]: value ? value : null
		}));
	};

	const handleSubmit = async () => {
		setIsLoading(true);
		await ApiClient.PUT(`${BASE_URL}/supplier/${id}/production-capacity`, inputData, '', true)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					dispatch(fetchSupplierDetails(id));
					handleClose();
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				toastError(response.data.message);
			});
	};
	const renderProductionItems = () => {
		const pcsItems = ['sewing', 'finishing', 'washing'];
		if (!productionCapacity) {
			return null;
		}
		let visibleFields = ['knitting', 'dyeing', 'sewing', 'washing'];
		return Object.keys(productionCapacity)?.map((type) => {
			if (visibleFields.includes(type)) {
				return (
					<div key={type} className="single same-padding-box">
						<p className="regular-14 gray_dark_02">{capitalizeFirstLetter(type)}</p>
						<h3 className="title regular-18 gray_dark_01 weight-500">
							{type === 'sales' ? (
								productionCapacity?.sales && '$' + getNumberUnit(productionCapacity?.sales)
							) : (
								<>
									{productionCapacity[type]} {pcsItems?.includes(type) ? 'Pcs' : 'Ton'}
								</>
							)}
							<span className="regular-14 gray_dark_02 font-weight-normal">/Per month</span>
						</h3>
					</div>
				);
			}
		});
	};

	return (
		<LoaderComponent loading={isLoading}>
			<div className="capacity-section section-padding hover-section">
				<h3 className="suplier-title pb-4 font-weight-bold regular-16">
					Production capacity
					<EditButton onEditClick={() => setShow(true)} />
				</h3>
				{productionCapacity && Object.keys(productionCapacity).length > 0 ? (
					<div className="capacity-items">{renderProductionItems()}</div>
				) : (
					<NoData message="No production capacity added" />
				)}
			</div>
			<Modal
				className="production-capacity-popup"
				show={show}
				onHide={handleClose}
				backdrop="static"
				centered
			>
				<div className="common-popup">
					<Modal.Header closeButton>
						<h3 className="semibold-16 mb-0">Production Capacity</h3>
					</Modal.Header>
					<Modal.Body>
						<div className="common-popup-body">
							<div className="capacity-item d-flex justify-content-between align-items-center">
								<p className="regular-14 gray_dark_01 weight-500">Knitting</p>
								<input
									onChange={handleChange}
									name="knitting"
									type="text"
									autoComplete="off"
									value={inputData?.knitting}
									placeholder="1500 ton/month"
									onKeyPress={validateNumber}
								/>
							</div>
							<div className="capacity-item d-flex justify-content-between align-items-center">
								<p className="regular-14 gray_dark_01 weight-500">Dyeing</p>
								<input
									onChange={handleChange}
									name="dyeing"
									type="text"
									autoComplete="off"
									value={inputData?.dyeing}
									placeholder="1500 ton/month"
									onKeyPress={validateNumber}
								/>
							</div>
							<div className="capacity-item d-flex justify-content-between align-items-center">
								<p className="regular-14 gray_dark_01 weight-500">Sewing</p>
								<input
									onChange={handleChange}
									name="sewing"
									type="text"
									autoComplete="off"
									value={inputData?.sewing}
									placeholder="1500 pcs/month"
									onKeyPress={validateNumber}
								/>
							</div>
							<div className="capacity-item d-flex justify-content-between align-items-center">
								<p className="regular-14 gray_dark_01 weight-500">Washing</p>
								<input
									onChange={handleChange}
									name="washing"
									type="text"
									autoComplete="off"
									value={inputData?.washing}
									placeholder="1500 pcs/month"
									onKeyPress={validateNumber}
								/>
							</div>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<button onClick={handleSubmit} className="button size32 ml-2" disabled={isLoading}>
							Submit
						</button>
					</Modal.Footer>
				</div>
			</Modal>
		</LoaderComponent>
	);
};

export default ProductionCapacity;
